__turbopack_context__.v({
  "event": "YwyRCW_event",
  "event-badge": "YwyRCW_event-badge",
  "event-content": "YwyRCW_event-content",
  "event-dates": "YwyRCW_event-dates",
  "event-header": "YwyRCW_event-header",
  "event-info": "YwyRCW_event-info",
  "event-media": "YwyRCW_event-media",
  "event-subheader": "YwyRCW_event-subheader",
  "event-subtitle": "YwyRCW_event-subtitle",
  "event-title": "YwyRCW_event-title",
});
